import * as React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import * as moment from 'moment';
import { defaultStore, loadState, combinedReducer, initializeDefaultStore } from '../common/redux-state'
import { storeUrl } from '../common/redux-state/actions/listing';
import { ProviderApp } from './components/app';
import { storeFilterOptions, upsertFilter } from '../common/redux-state/actions/filters';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

var providerSearch = document.getElementById("provider-entry-js");
var query = providerSearch.getAttribute("data-query");
var searchByLocation = providerSearch.getAttribute("data-search-by-location");
var isRadiusSearch = providerSearch.getAttribute("data-radius-search");
var sortByLocation = providerSearch.getAttribute("data-sort-by-location");
var parentID = providerSearch.getAttribute("data-get-children-pages");
var searchUrl = providerSearch.getAttribute("data-provider-search-url");
var dontSearchOnPageLoad = providerSearch.getAttribute("data-dont-search-on-page-load") === "True";
defaultStore.dispatch(storeUrl("/api/SearchResult/GetProviders?"));
defaultStore.dispatch(storeFilterOptions("/api/SearchResult/GetProviderFilters") as any);
defaultStore.dispatch(upsertFilter("QueryValue", query));
if (parseInt(parentID) > 0) {
    defaultStore.dispatch(upsertFilter("LocationParent", parentID));
}
else {
    defaultStore.dispatch(upsertFilter("QueryValue", encodeURIComponent(query)));

}
var defaultSearchBox = query;
const savedState = loadState("providerState");
let updatedStore;
if (savedState) {
    savedState.filtersState.currentMonth = moment(savedState.filtersState.currentMonth);
    updatedStore = createStore(combinedReducer, savedState, applyMiddleware(thunk));
    defaultSearchBox = savedState.filtersState.filters["QueryValue"];
}

initializeDefaultStore(updatedStore ? updatedStore : defaultStore, dontSearchOnPageLoad);
var prevQuery = sessionStorage.getItem("prevQueryString")
if (prevQuery != query && updatedStore) {
    sessionStorage.setItem("prevQueryString", query);
    updatedStore.dispatch(upsertFilter("QueryValue", encodeURIComponent(query)));
    defaultSearchBox = query;
}

var prevLocation = sessionStorage.getItem("prevLocation")
if (prevLocation != parentID && updatedStore && parseInt(parentID) > 0) {
    sessionStorage.setItem("prevLocation", parentID);
    updatedStore.dispatch(upsertFilter("LocationParent", parentID));
}
render(<Provider store={updatedStore ? updatedStore : defaultStore}>
    <ProviderApp searchByLocation={searchByLocation === "True"} sortByLocation={sortByLocation === "True"} radiusSearch={isRadiusSearch === "true" || isRadiusSearch === "True"} searchBoxDefault={defaultSearchBox} hospitalSearch={parseInt(parentID) > 0 ? true : false} locationSearchUrl={searchUrl} />
</Provider>, providerSearch);
